/* @flow */

const LINKS = {
  AppleAppStore:
    'https://itunes.apple.com/app/apple-store/id919765207?pt=107386822&ct=lugg.com&mt=8',
  Blog: 'https://blog.lugg.com',
  SupportEmail: 'support@lugg.com',
  PartnersEmail: 'partners@lugg.com',
  CareersEmail: 'jobs@lugg.com',
  Facebook: 'https://facebook.com/lugg',
  GooglePlayStore: 'https://play.google.com/store/apps/details?id=com.lugg',
  Instagram: 'https://instagram.com/lugg',
  Jobs: 'https://angel.co/lugg/jobs',
  Twitter: 'https://twitter.com/lugg',
  Yelp: 'https://www.yelp.com/biz/lugg-san-francisco-4',
  GoogleReviews:
    'https://www.google.com/search?q=google+lugg&oq=google+lugg&ie=UTF-8#q=lugg&lrd=0x80858078d1a1d46f:0x9ab9b06a86ff94ed,1,',
  PartnersFliersForm: 'http://bit.ly/2DZ69Gl',
  Youtube: 'https://www.youtube.com/channel/UC1XNu5o7S_zVKISNDJI3uFg',
  Tiktok: 'https://www.tiktok.com/@luggapp',
};

export default LINKS;



// WEBPACK FOOTER //
// ./src/data/Links.js